import { Tooltip } from 'antd';
import dayjs from 'dayjs';
import pluralize from 'pluralize';
import styles from 'styles/components/cycleDeadline.module.scss';

const CycleDeadline = ({ deadline }) => (
  <div
    className={styles.cycleDeadline}
    style={{
      color: dayjs(deadline).diff(dayjs(), 'day') <= 3 ? 'red' : 'black',
    }}
  >
    <Tooltip
      title={<div>Deadline: {dayjs(deadline).format('YYYY-MM-DD HH:mm')}</div>}
    >
      {dayjs(deadline).isBefore(dayjs()) ? (
        <span style={{ color: '#389e0d' }}>Cycle ended</span>
      ) : (
        <>
          {dayjs(deadline).diff(dayjs(), 'day') > 0
            ? `${dayjs(deadline).diff(dayjs(), 'day')} ${pluralize(
                'day',
                dayjs(deadline).diff(dayjs(), 'day')
              )}
        remaining`
            : 'Last day to respond'}{' '}
        </>
      )}
    </Tooltip>
  </div>
);

export default CycleDeadline;
